import React from 'react';
import Button from '@zola/zola-ui/src/components/Button/ButtonV2';
import {
  CtaEventDataType,
  CTA_TYPES,
  trackCtaClicked,
} from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import type { MegaMenuCallToAction } from 'components/navV2/NavData/types';
import type { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';
import { BusinessUnit } from '@zola-helpers/client/dist/es/@types';

import TextUtil from 'util/TextUtil';
import pinkArrow from 'assets/images/icons/pink_arrow.svg';
import css from './subMenuLeftColumn.module.less';
import { NAV_SECTIONS } from '../../../../util/trackNavigationClickedHelpers';

export type SubMenuLeftColumnProps = {
  activeNavType: PrimaryNavIdentifier;
  cta: MegaMenuCallToAction;
  title: string;
  businessUnit?: BusinessUnit;
};

const SubMenuLeftColumn = ({
  cta,
  title,
  businessUnit,
  activeNavType,
}: SubMenuLeftColumnProps): JSX.Element => {
  const ctaEventData: CtaEventDataType = {
    business_unit: businessUnit,
    cta_type: CTA_TYPES.BUTTON,
    group_id: NAV_SECTIONS.primarySubNav,
    cta_id: TextUtil.toAllUpperCase(activeNavType),
    position: 1,
    location: NAV_SECTIONS.primarySubNav,
    section: TextUtil.toAllUpperCase(activeNavType),
    cta: cta.path,
  };

  const handleCtaClick = () => {
    trackCtaClicked(ctaEventData);
  };

  return (
    <div className={css.component}>
      <span className={css.title}>Your {title}</span>
      <Button className={css.ctaButton} href={cta.path} component="a" onClick={handleCtaClick}>
        {cta.title}
      </Button>
      <img className={css.arrow} src={pinkArrow} alt="see why below" />
      <ul>
        {cta.items.map((item, i) => (
          <li className={css.listItem} key={i}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SubMenuLeftColumn;
